// Root navigation singleton. Lets non-React modules (push handlers,
// background tasks, Redux thunks) navigate without prop drilling the
// `navigation` object.
//
// `App.tsx` calls `setNavigationRef` once on mount so this module always
// points at the live React Navigation container ref. Consumers should treat
// `navigate` / `getCurrentRoute` as best-effort: if the navigator hasn't
// mounted yet (cold start before App's onReady fires) the calls become
// no-ops and we just log a warning.

let navigationRef = null;

function setNavigationRef(ref) {
  navigationRef = ref;
}

function isReady() {
  return !!navigationRef && typeof navigationRef.isReady === 'function' && navigationRef.isReady();
}

function navigate(name, params) {
  if (!navigationRef) {
    console.warn('[RootNavigation] navigate called before navigationRef was set:', name);
    return;
  }
  if (!isReady()) {
    // The container hasn't finished mounting yet (cold start from a
    // notification tap). Defer one tick and try again.
    setTimeout(() => {
      try {
        if (isReady()) navigationRef.navigate(name, params);
      } catch (e) {
        console.warn('[RootNavigation] deferred navigate failed:', e);
      }
    }, 100);
    return;
  }
  try {
    navigationRef.navigate(name, params);
  } catch (e) {
    console.warn('[RootNavigation] navigate failed:', e);
  }
}

function getCurrentRoute() {
  try {
    return navigationRef && typeof navigationRef.getCurrentRoute === 'function'
      ? navigationRef.getCurrentRoute()
      : null;
  } catch {
    return null;
  }
}

module.exports = {
  setNavigationRef,
  navigate,
  getCurrentRoute,
  isReady,
  // CommonJS doesn't expose `navigationRef` directly because it changes; use
  // the helpers above instead.
};
